import { App, Button, Input } from "antd"
import { OTPRef } from "antd/es/input/OTP"
import { useRef, useState } from "react"
import styled from "styled-components"

import ButtonToggleModal from "#blocks/ButtonToggleModal"
import Flex from "#blocks/Flex"
import { Uuid } from "#customTypes/globalTypes"
import { assignPinToUser, generateUniquePin } from "#utils/authHelpers"

const SOtpInput = styled(Input.OTP)`
  width: 300px;
  user-select: none;
`

const PinGenerator = ({ userId }: { userId: Uuid }) => {
  const inputRef = useRef<OTPRef>(null)
  const [pin, setPin] = useState<string>("")
  const [isOpen, setIsOpen] = useState(false)

  const handleGeneratePin = async () => {
    const newPin = await generateUniquePin()
    setPin(newPin)
  }
  const { message, modal } = App.useApp()

  const handleSubmit = async () => {
    try {
      if (!userId) throw new Error("User must be saved first!")

      await assignPinToUser(userId, pin)
      message.success("Pin saved")
      setTimeout(() => {
        handleToggle()
      }, 2200)
    } catch (error) {
      modal.error({
        title: "Something went wrong",
        content: `Failed to save pin: ${error}`,
      })
    }
  }

  const handleToggle = (newIsOpen?: boolean) => {
    setIsOpen(newIsOpen ?? false)
    setPin("")
    if (newIsOpen) {
      generateUniquePin().then(setPin)
    }
  }

  if (!userId) return <Button disabled>Generate pin</Button>

  return (
    <ButtonToggleModal
      modalTitle="Create pin"
      buttonLabel="Create pin"
      onOk={handleSubmit}
      okText="Save"
      open={isOpen}
      onToggle={handleToggle}
    >
      <Flex col gap={10} center style={{ height: 250 }}>
        <Flex style={{ marginBottom: 16 }}>
          Memorize your pin! It will not be shown again.
        </Flex>
        <SOtpInput
          ref={inputRef}
          length={4}
          value={pin}
          onChange={setPin}
          disabled
        />
        <Button type="primary" onClick={handleGeneratePin}>
          Generate pin
        </Button>
      </Flex>
    </ButtonToggleModal>
  )
}

export default PinGenerator
